interface SectionHeadingProps {
  no: string;
  title: string;
  english: string;
  desc: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ no, title, english, desc, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`flex flex-col ${isCenter ? 'items-center text-center' : 'items-start'}`}>
      <div className="flex items-baseline gap-3">
        <span className="font-heading text-2xl md:text-3xl font-black text-primary-500 leading-none">{no}</span>
        <span className="h-[2px] w-10 bg-accent-500" />
        <span className="font-label text-[11px] tracking-[0.28em] text-foreground-500 uppercase">{english}</span>
      </div>
      <h2 className="mt-4 font-heading text-3xl md:text-[40px] font-black leading-tight text-foreground-950">{title}</h2>
      <p className={`mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 ${isCenter ? 'mx-auto' : ''}`}>
        {desc}
      </p>
    </div>
  );
}